import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
`;

export const CourseDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputContainerCourse = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`;

export const InputContainerYear = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
`;
